<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{souscripteurLibelle}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busyGet,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <mat-tab-group mat-align-tabs="start" #tabGroup (selectedIndexChange)="selectedChangeValue($event)"
                  [(selectedIndex)]="indiceTab">
                  <mat-tab label="INFO DE BASE">
                    <div *ngIf="indiceTab == 0" style="overflow-x: hidden;padding: 10px;">
                        <app-souscripteur-base-info [souscripteurData]="souscripteurData" (onGetsouscripteurInfo)="onGetsouscripteurInfo($event)"></app-souscripteur-base-info>
                    </div>
                  </mat-tab>
                  <mat-tab label="POLICES">
                    <div *ngIf="indiceTab == 1" style="overflow-x: hidden;padding: 10px;">
                        <app-souscripteur-detail-police [souscripteurData]="souscripteurData"></app-souscripteur-detail-police>
                    </div>
                  </mat-tab>
                  <mat-tab label="COLLEGES">
                    <div *ngIf="indiceTab == 2" style="overflow-x: hidden;padding: 10px;">
                        <app-souscripteur-detail-college [souscripteurData]="souscripteurData"></app-souscripteur-detail-college>
                    </div>
                  </mat-tab>
                </mat-tab-group>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
     

        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>